import React from 'react'
import CountUp from 'react-countup'
import { Container, Row, Button, Col } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

const InfoSection = ({
    infos = []
}) => {
    return (
        <section className="info-section">
            <Container>
                <Row>
                    {infos.map(({ title, number }) => {
                        const isK = (number / 1000) >= 1;
                        const kProps = isK ? { decimals: 1, suffix: 'K', end: (number / 1000) } : {}
                        return (
                            <Col md={12 / infos.length} key={title}>
                                <div className="info-wrapper">
                                    <h6 className="title">{title}</h6>
                                    <CountUp className="number" end={number} duration={10} {...kProps} />
                                </div>
                            </Col>
                        )
                    })}
                </Row>
                <hr />
                <div className="join-wrapper">
                    <h3 className="title">Get onborded now!</h3>
                    <Button variant="light" className="lg" as={NavLink} to="/signup">Register Now</Button>
                </div>
            </Container>
        </section>
    )
}

export default InfoSection
